import { Outlet, useLocation } from 'react-router';
import Header from './header';
import { styled } from '@mui/material';

const imageUrl = 'back-01.png';
const LayoutRoot = styled('div')(({ theme }) => ({
	flex: '1 1 auto',
	display: 'flex',
	backgroundImage: `url(${imageUrl})`,
	backgroundSize: '100% 100%',
	objectFit: 'cover',
}));

const LayoutRootAuth = styled('div')(({ theme }) => ({
	flex: '1 1 auto',
	display: 'flex',
}));

const Rootdiv = styled('div')(({ theme }) => ({
	flex: '1 1 auto',
	display: 'flex',
	height: '100vh',
	flexDirection: 'column',
}));
const AppLayout = () => {
	const location = useLocation();

	return (
		<Rootdiv>
			{location.pathname === '/dashboard' ||
			location.pathname === '/privacy-policy' ? (
				<Header />
			) : null}
			{location.pathname === '/dashboard' ? (
				<LayoutRootAuth>
					<Outlet />
				</LayoutRootAuth>
			) : (
				<LayoutRoot>
					<Outlet />
				</LayoutRoot>
			)}
		</Rootdiv>
	);
};

export default AppLayout;
